<script setup>
import EditUser from '@/Pages/Users/Edit.vue';
import { useForm } from '@inertiajs/inertia-vue3';
import { ref } from "vue"

const form = useForm(props.user);

const props = defineProps({
    user: {
        type: Object,
        required: true
    },
	roles: {
		type: Array,
		required: true,
	},
})

const userPermissions = ref([])

const updateUser = () => {
    form.transform((data) => {
		data.permissions = props.user.role == 'admin' ? [] : userPermissions.value
		return data
	}).put('/users/' + props.user.id)
}

function setPermissions(permissions) {
	userPermissions.value = permissions
}

</script>

<template>
	<EditUser 
		:user="form" 
		:roles="roles"
		@update:users="updateUser"
		@set-permissions="setPermissions"
	/>
</template>